var exports = {
  "D": "x43aef4ae--349c6f--pik-number",
};

module.exports = exports;
